module.exports = __webpack_public_path__ + "img/personaje-vista-1.d487f0a2.jpg";